
//
const zenoFetch = require('../utils/zenoFetch.js');
const debounce  = require('../utils/debounce.js');

//handle the cookie notification bar
document.querySelector('.cookie-control-bar')?.addEventListener('click', debounce(200, async (event) => {

    //
    const action = event.target.getAttribute('data-action');

    //
    if (action === 'accept-cookies' || action === 'reject-cookies') {
        const [ status ] = await zenoFetch('post', '/cookie.php', null, { action });
        if (status == 'success') {

            //hide the cookie bar
            document.querySelector('.cookie-control-bar').style.display = 'none';

            //recompute the header offset (needed for proper functioning of the header (on small viewports))
            const siteHeaderOffset = document.querySelector('.site-header')?.getBoundingClientRect().bottom;
            document.body.style.setProperty('--header-offset', `${siteHeaderOffset}px`);

            //recompute the sidebar offset (needed for proper functioning of the header (on small viewports))
            const siteSidebarOffset = document.querySelector('.site-sidebar')?.getBoundingClientRect().bottom;
            document.body.style.setProperty('--scroll-margin-top', `${siteSidebarOffset}px`);

        }
    }

}));